var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { pc: !_vm.isMobile }, attrs: { id: "app" } },
    [
      _c("minesweeper-controller", {
        attrs: {
          "is-mobile": _vm.isMobile,
          width: _vm.width,
          height: _vm.height,
          "mines-count": _vm.minesCount
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }